"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
import fetch from "../util/fetch";
const baseUrl = "/api/customers";
const customerUrl = (customerId, lastPart = "") => {
  return [baseUrl, customerId, lastPart].join("/");
};
export default {
  update: function(customerId, customer) {
    return ApiService.addErrorHandler(fetch(customerUrl(customerId), {
      method: "put",
      data: { customer }
    }));
  },
  _update: function(url, verb, params) {
    return ApiService.addErrorHandler(fetch(url, {
      method: verb,
      data: params
    }).then(DataStoreService.responseHandler, _.identity));
  },
  customersWithIds: function(ids) {
    return ApiService.addErrorHandler(fetch(baseUrl, { data: { ids } }));
  },
  customerWithId: function(customerId) {
    return ApiService.addErrorHandler(fetch(customerUrl(customerId)));
  },
  filtered: function(filters) {
    return fetch(baseUrl, { data: filters });
  },
  setCustomerVisibleDocumentTypes: function(types, customer) {
    return this._update(
      customerUrl(customer.id, "customer_visible_document_types"),
      "put",
      { customer_visible_document_types: types }
    );
  },
  clearCustomerVisibleDocumentTypes: function(customer) {
    return this._update(
      customerUrl(customer.id, "customer_visible_document_types"),
      "delete"
    );
  },
  setRequiredReceivablesDocumentTypes: function(types, customer) {
    return this._update(
      customerUrl(customer.id),
      "put",
      { customer: { required_receivables_types: types } }
    );
  },
  clearRequiredReceivablesTypes: function(customer) {
    return this._update(
      customerUrl(customer.id),
      "put",
      { customer: { required_receivables_types: "reset" } }
    );
  }
};
